import {
  Box, Grid, makeStyles,
} from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  summary: {
    margin: theme.spacing(2, 0, 0, 0),
  },
  containerButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: theme.spacing(2, 0),
    width: '95%',
  },
}));
function SkeletonLesson() {
  const classes = useStyles();
  return (
    <Grid container direction="row">
      <Grid container>
        <Grid item xs={8}>
          <Grid item xs={12}>
            {' '}
            <Skeleton variant="rect" width="95%" height={470} />
          </Grid>

          <Box className={classes.containerButtons}>
            <Skeleton variant="rect" width={180} height={45} />
            <Skeleton variant="rect" width={180} height={45} />
            <Skeleton variant="rect" width={180} height={45} />
          </Box>
          <Skeleton variant="rect" width="95%" height={80} />
          <Skeleton variant="rect" width="95%" height={170} />
        </Grid>
        <Grid item xs={4}>
          <Box>
            <Skeleton variant="rect" width={480} height={80} />
          </Box>
          <Box className={classes.summary}>
            <Skeleton variant="rect" width={480} height={80} />
          </Box>
          <Box className={classes.summary}>
            <Skeleton variant="rect" width={480} height={80} />
          </Box>
          <Box className={classes.summary}>
            <Skeleton variant="rect" width={480} height={80} />
          </Box>
          <Box className={classes.summary}>
            <Skeleton variant="rect" width={480} height={80} />
          </Box>
          <Box className={classes.summary}>
            <Skeleton variant="rect" width={480} height={120} />
          </Box>
          <Box className={classes.summary}>
            <Skeleton variant="rect" width={480} height={120} />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SkeletonLesson;
